import { CALL_API } from '../../../../../../../middlewares/api';
import { url } from '../../../../../../../configs/';
const {
  API_SERVER,
} = url;
const FETCH_INTERNAL_LINKS_REQUEST = 'tube/internalLinks/FETCH_INTERNAL_LINKS_REQUEST';
const FETCH_INTERNAL_LINKS_SUCCESS = 'tube/internalLinks/FETCH_INTERNAL_LINKS_SUCCESS';
const FETCH_INTERNAL_LINKS_FAIL = 'tube/internalLinks/FETCH_INTERNAL_LINKS_FAIL';

export default function reducer(state = {
  isLoading: false,
  links: [],
}, action) {
  switch (action.type) {
    case FETCH_INTERNAL_LINKS_REQUEST:
      return Object.assign({}, state, {
        isLoading: true,
      });
    case FETCH_INTERNAL_LINKS_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        links: action.response,
      });
    default:
      return state;
  }
}

export function fetchInternalLinks() {
  return {
    [CALL_API]: {
      url: `${API_SERVER}company/COMP_InternalSystemLink/Get`,
      method: 'GET',
      types: [
        FETCH_INTERNAL_LINKS_REQUEST,
        FETCH_INTERNAL_LINKS_SUCCESS,
        FETCH_INTERNAL_LINKS_FAIL,
      ],
    },
  };
}



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/417/s/Tube.Frontend/src/containers/App/screens/Tube/screens/InternalLinks/reducers/index.js
 **/